import Select from './Select.vue';

Select.install = (Vue) => {
  Vue.component(Select.name, Select);
};

export default Select;
